import BasePage from '@/common/BasePage';
import AppUtil from '@/util/AppUtil';

/**单个列表基类*/
export default class BaseList extends BasePage {
    loading=false;
    finished=false;
    error=false;
    list:any[]=[];
    /**
     * @description 请求列表的地址
     */
    protected reqUrl="/zhServe/serve/getServeList";
    protected reqData:any={page:0,limit:10};
     req_items(){
       
        this.reqData.page++;
        AppUtil.request({
            url: this.reqUrl,
            method: "post",
            data: this.reqData,
        },this.get_items)
    }
    protected get_items(res: any){
        
       
        this.finished=true;//当res.data为空时，结束请求，兼容请求过程中后台新增情况
        this.loading=false;
        if(res.data){
           let list=res.data.map(this.init_item);
           this.reqData.page>1?this.list=this.list.concat(list):this.list=list;
        //    if(res.count){
            this.finished=this.list.length>=res.count;//通过数量判断是否已经结束
        //    }else if(res.data.length){
        //     this.finished=false;
        //    }
           
        }
        console.log("this.list",this.list);
    }
    protected init_item(val: any){
        return val;
        // console.log("val",val)
    }
}
